import { ActivityBatchDispatchedType, ActivityFeedEventIdEnum } from '@ukpostbox/client-data/lib/Types/ClientTypes';
import { ListItem, useLayout } from '@ukpostbox/frontend-framework';
import { FormatLocaleRelativeStrict } from '@ukpostbox/helpers';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';
import { MailItemThumbnail } from '../../../Mailboxes/Components/Thumbnails/Entries/MailItemThumbnail';
import { MailItemNoThumbnail } from '../../../Mailboxes/Components/Thumbnails/Entries/MailItemNoThumbnail';
import { MailPartTypeEnum } from '../../../Mailboxes/Components/Thumbnails/Types/ThumbnailTypes';

function ActivityEventBatch(item: ActivityBatchDispatchedType) {
	const { currentLocale } = useSite();
	const { isTiny, isSmall } = useLayout();

	return (
		<ListItem
			actionLink={{ url: `./mail/forwarding-batches/${item.metadata.batchId}` }}
			addonLeft={
				item.eventId === ActivityFeedEventIdEnum.BatchDispatched &&
				item.metadata.batchThumbnails &&
				item.metadata.batchThumbnails[0]?.thumbnails[0]?.linkToFile ? (
					<MailItemThumbnail {...item?.metadata.batchThumbnails[0]?.thumbnails[0]} />
				) : (
					<MailItemNoThumbnail mailType={MailPartTypeEnum['Mail-Envelopes']} />
				)
			}
			title={item.message}
			description={isTiny || isSmall ? FormatLocaleRelativeStrict(item.eventDate, currentLocale) : undefined}
			addonRight={
				!isTiny && !isSmall ? { content: FormatLocaleRelativeStrict(item.eventDate, currentLocale) } : undefined
			}
		/>
	);
}

export { ActivityEventBatch };
